import legalPDF from '../../../assets/documents/EQUITRACK Website T&C 8 Feb 2024.pdf';
import privacyPolicyPDF from '../../../assets/documents/EQUITRACK Privacy Policy 8 Feb 2024.pdf';

export default function LegalLinks() {
 return (
  <div className="d-flex flex-column align-items-start">
   <a target="_blank" rel="noreferrer" href={privacyPolicyPDF} className="info-link">Privacy Policy</a>
   <a target="_blank" rel="noreferrer" href={legalPDF} className="info-link">Legal</a>
  </div>
 )
}